export type Sesong = 'vaar' | 'sommer' | 'bokhost' | 'jul' | 'vinter';

export const DAGER_PER_AAR = 120;

export const SESONG_NAVN: Record<Sesong, string> = {
  vaar: 'Vår',
  sommer: 'Sommer',
  bokhost: 'Bokhøst',
  jul: 'Jul',
  vinter: 'Vinter',
};

export const SESONG_BESKRIVELSE: Record<Sesong, string> = {
  vaar: 'Det er nå Vår. Forfatterne våkner, agentene ringer.',
  sommer: 'Det er nå Sommer. Folk er på hytta — salget dipper.',
  bokhost: 'Det er nå Bokhøst. Power-vinduet er åpent. Alt koster og selger mer.',
  jul: 'Det er nå Jul. Barnebok og feelgood selger gull.',
  vinter: 'Det er nå Vinter. Manus-tørke. Bruk tiden til å planlegge.',
};

export type SesongModifikator = {
  salgMultPerSjanger: Record<string, number>;
  manusFrekvens: number;
  kampanjePrisMult: number;
  salgGrunnMult: number;
};

export const SESONG_MODIFIKATORER: Record<Sesong, SesongModifikator> = {
  vaar: {
    salgMultPerSjanger: { LITERARY: 1.1, NONFICTION: 1.1 },
    manusFrekvens: 1.3,
    kampanjePrisMult: 1.0,
    salgGrunnMult: 1.0,
  },
  sommer: {
    salgMultPerSjanger: { FEELGOOD: 1.2, ROMANCE: 1.2, KRIM: 1.1 },
    manusFrekvens: 0.7,
    kampanjePrisMult: 0.8,
    salgGrunnMult: 0.7,
  },
  bokhost: {
    salgMultPerSjanger: { LITERARY: 1.4, NONFICTION: 1.3, POETRY: 1.3 },
    manusFrekvens: 1.5,
    kampanjePrisMult: 1.4,
    salgGrunnMult: 1.3,
  },
  jul: {
    salgMultPerSjanger: { BARNEBOK: 1.8, FEELGOOD: 1.5, NONFICTION: 1.2 },
    manusFrekvens: 1.0,
    kampanjePrisMult: 1.3,
    salgGrunnMult: 1.2,
  },
  vinter: {
    salgMultPerSjanger: {},
    manusFrekvens: 0.5,
    kampanjePrisMult: 0.7,
    salgGrunnMult: 0.6,
  },
};

export function dagIAaret(dag: number): number {
  const mod = ((dag - 1) % DAGER_PER_AAR + DAGER_PER_AAR) % DAGER_PER_AAR;
  return mod + 1;
}

export function aaret(dag: number): number {
  return Math.floor((dag - 1) / DAGER_PER_AAR) + 1;
}

export function sesongForDag(dag: number): Sesong {
  const d = dagIAaret(dag);
  if (d <= 20) return 'vaar';
  if (d <= 60) return 'sommer';
  if (d <= 80) return 'bokhost';
  if (d <= 100) return 'jul';
  return 'vinter';
}

export function sesongMod(dag: number): SesongModifikator {
  return SESONG_MODIFIKATORER[sesongForDag(dag)];
}

export function sesongSalgFaktor(dag: number, genre: string): number {
  const mod = sesongMod(dag);
  const sjangerMult = mod.salgMultPerSjanger[genre] ?? 1.0;
  return sjangerMult * mod.salgGrunnMult;
}
